import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import ConfigurationRuleFormPage from "@/pages/games/GameDisplay/children/configurations/ConfigurationRuleFormPage/ConfigurationRuleFormPage.vue";
import ConfigurationsListPage from "@/pages/games/GameDisplay/children/configurations/ConfigurationsListPage/ConfigurationsListPage.vue";

import links from "./links";

const { canReadConfigurations, canWriteConfigurations } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: ":classId/rules/new",
    component: ConfigurationRuleFormPage,
    name: links.games.configurations.newRule,
    props: true,
    meta: {
      title: "New rule",
      permission: canWriteConfigurations,
    },
  },
  {
    path: ":classId/rules/:ruleId/preview",
    component: ConfigurationRuleFormPage,
    name: links.games.configurations.previewRule,
    props: (route) => ({ ...route.params, preview: true }),
    meta: {
      title: "Preview rule",
      permission: canReadConfigurations,
    },
  },
  {
    path: ":classId/rules/:ruleId/duplicate",
    component: ConfigurationRuleFormPage,
    name: links.games.configurations.duplicateRule,
    props: (route) => ({ ...route.params, duplicate: true }),
    meta: {
      title: "Duplicate rule",
      permission: canWriteConfigurations,
    },
  },
  {
    path: ":classId/rules/:ruleId/edit",
    component: ConfigurationRuleFormPage,
    name: links.games.configurations.editRule,
    props: true,
    meta: {
      title: "Edit rule",
      permission: canWriteConfigurations,
    },
  },
  {
    path: "",
    component: ConfigurationsListPage,
    name: links.games.configurations.list,
    props: true,
    meta: {
      title: "Configurations",
      permission: canReadConfigurations,
    },
  },
];
